import React, { useState } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { Header, Titulo, ContenedorHeader } from "./../elementos/Header";
import Boton from "./../elementos/Boton";
import {
  Formulario,
  Input,
  ContenedorBoton
} from "./../elementos/ElementosDeFormulario";
import { ReactComponent as SvgLogin } from "./../imagenes/registro.svg";
import { auth } from "./../firebase/firebaseConfig";
import { useHistory } from "react-router-dom";
import Alerta from './../elementos/Alerta';

const Svg = styled(SvgLogin)`
  width: 100%;
  max-height: 6.25rem; /*100px */
  margin-bottom: 1.25rem; /* 20px */
`;

const RegistroUsuarios = () => {
  const history = useHistory();
  const [correo, establecerCorreo] = useState("");
  const [password, establecerPassword] = useState("");
  const [password2, establecerPassword2] = useState("");
  //estados de alertas de formulario
  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({});

  const handleChange = e => {
    switch (e.target.name) {
      case "email":
        establecerCorreo(e.target.value);
        //console.log(correo);
        break;
      case "password":
        establecerPassword(e.target.value);
        //console.log(password);
        break;
      case "password2":
        establecerPassword2(e.target.value);
        //console.log(password2);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    //console.log(correo, password, password2);
    cambiarEstadoAlerta(false);
    cambiarAlerta({});
    //comprobamos del lado del cliente que el correo sea valido.
    const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
    //console.log(expresionRegular.test(correo));
    if (!expresionRegular.test(correo)) {
      //console.log("Ingresa un correo valido");
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: 'error',
        mensaje: 'Ingrese un correo electrónico correcto'
      })
      return;
    }
    if (correo === "" || password === "" || password2 === "") {
      //console.log("Por favor rellena todos los datos");
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: 'error',
        mensaje: 'Por favor rellena todos los datos'
      })
      return;
    }
    if (password !== password2) {
      //console.log("Las contraseñas no son iguales");
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: 'error',
        mensaje: 'Las contraseñas no son iguales'
      })
      return;
    }

    //console.log('Registramos usuario');
    //registro con firebase.auth
    /*
    auth
      .createUserWithEmailAndPassword(correo, password)
      .then(() => {
        console.log("Usuario registrado con éxito");
      })
      .catch(error => {
        console.log(error);
      });
    */
    try {
      await auth.createUserWithEmailAndPassword(correo, password);
      //console.log("Usuario registrado con éxito");
      history.push("/");
    } catch (error) {
      //console.log(error);
      cambiarEstadoAlerta(true);
      let mensaje;
      switch (error.code) {
        case "auth/invalid-password":
          mensaje = "La contraseña tiene que ser al menos de 6 caracteres";
          break;
        case "auth/email-already-in-use":
          mensaje = "Ya existe una cuenta con el correo electrónico proporcionado.";
          break;
        case "auth/invalid-email":
          mensaje = "El correo electrónico no es válido.";
          break;
        default:
          mensaje = "Hubo un error al intentar crear la cuenta.";
          break;
      }
      //console.log(mensaje);
      cambiarAlerta({
        tipo: 'error',
        mensaje: mensaje
      })
    }
  };

  return (
    <>
      <Helmet>
        <title>Crear Cuenta</title>
      </Helmet>

      <Header>
        <ContenedorHeader>
          <Titulo>Crear Cuenta</Titulo>
          <div>
            <Boton to="/iniciar-sesion">Iniciar Sesión</Boton>
          </div>
        </ContenedorHeader>
      </Header>

      <Formulario onSubmit={handleSubmit}>
        <Svg />
        <Input
          type="email"
          name="email"
          placeholder="Correo Electrónico"
          value={correo}
          onChange={handleChange}
        />
        <Input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={password}
          onChange={handleChange}
        />
        <Input
          type="password"
          name="password2"
          placeholder="Repetir la contraseña"
          value={password2}
          onChange={handleChange}
        />
        <ContenedorBoton>
          <Boton as="button" primario type="submit">
            Crear cuenta
          </Boton>
        </ContenedorBoton>
      </Formulario>

      <Alerta 
        tipo={alerta.tipo}
        mensaje={alerta.mensaje}
        estadoAlerta={estadoAlerta}
        cambiarEstadoAlerta={cambiarEstadoAlerta}
      />
    </>
  );
};

export default RegistroUsuarios;
